import React, {useRef, useState, useEffect } from 'react';
import { formatMoneda } from '../../../util/varios';
import { TableBody, TableRow, TableCell, InputAdornment } from '@mui/material'

;

import useTableFijo from "../../useTableFijo"


const TablaDeudaLicores = (props) => {
    let op = require('../../../../src/modulos/datos');

    const [titulo, setTitulo] = useState();
    const [msg, setMsg] = useState();
    const [mostrar, setMostrar] = useState(false);
    const [mostrar3, setMostrar3] = useState(false);
    const [mostrar4, setMostrar4] = useState(false);
    const [deuda, setDeuda] = useState();
    const [interes, setInteres] = useState();
    const [recargo, setRecargo] = useState();
    const [multa, setMulta] = useState();
    const [totDeuda, setTotDeuda] = useState();
    const [credito, setCredito] = useState(0.00);
    const [visibleF, setVisibleF] = useState('hidden');
    const [records, setRecords] = useState([]);
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } });
    const txtBolivares = useRef();
    const txtPetro = useRef()

    const headCells = [
        { id: 'anio', label: 'AÑO', width: '100px', textAlign: "center", backgroundColor: 'rgba(5, 81, 130, 1)', fontSize: "10px", color: "white", disableSorting: true },
        { id: 'mes', label: 'MES', width: '100px', textAlign: "center", backgroundColor: 'rgba(5, 81, 130, 1)', fontSize: "10px", color: "white", disableSorting: true },
        { id: 'descripcion', label: 'DESCRIPCION', width: 'auto', textAlign: "center", backgroundColor: 'rgba(5, 81, 130, 1)', fontSize: "10px", color: "white", disableSorting: true },
        { id: 'monto', label: 'MONTO', width: '100px', textAlign: "center", backgroundColor: 'rgba(5, 81, 130, 1)', fontSize: "10px", color: "white", disableSorting: true },

    ];

    let heightTabla = 320;

    const {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting
    } = useTableFijo(records, headCells, filterFn, heightTabla);

    const calculo = () => {

        let deu = parseFloat(0.00);

        for (let i = 0; i < props.tabDeuda.length; i++) {
            deu = deu + parseFloat(props.tabDeuda[i].monto);
        }

        if(txtBolivares.current){
            setDeuda(formatMoneda(deu.toString().replace('.', ','), ',', '.', txtBolivares.current.checked ? 2 : 4));
            setTotDeuda(formatMoneda(deu.toString().replace('.', ','), ',', '.', txtBolivares.current.checked ? 2 : 4));
        }
        setRecords(props.tabDeuda);
    }

    useEffect(() => {


        if (props.tabDeuda) {


            calculo()
            setVisibleF(props.visibleF)



        }




    }, [props.tabDeuda]);

    const imprimirDeuda = (reporte) => (event) => {
        event.preventDefault();
        var idcomercio = "CONTRIB.CODIGO="+ props.idcomercio;
        window.open(op.reportes + "reporte=" + reporte + "&sql=" + idcomercio + "&valorpetro=" + props.petro + "&bolivares=" + (txtBolivares.current?.checked ? "1" : "2"), "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
      
    }


    return (
        <div >
            <div className="card-body" style={{ height: "100%" }}>
                <div className="content" >
                    <div className="container">
                        <div className="row col-md-12 d-flex justify-content-between" style={{ height: "100%" }}>
                        <div className='col-md-12 d-flex justify-content-end mb-2'>
                                    <button style={{ height: '30px' }} onClick={imprimirDeuda('EdoCtaRentaLic')} className="btn btn-sm btn-primary rounded-circle"><i className="fas fa-print"></i> </button>
                                </div>
                            <div className="col-md-12 mx-auto px-0">
                            <TblContainer container={{ height: 250, width: '100%', overflow: 'auto', padding: '2px' }} >

                                    <TblHead />

                                    <tbody>
                                        {

                                            records && records.map((item, index) => (
                                                <tr key={item.anio + item.mes} style={{ padding: "0" }}>
                                                    <td style={{ fontSize: "10px", textAlign: "center" }}>{item.anio}</td>
                                                    <td style={{ fontSize: "10px", textAlign: "center" }}>{item.mes}</td>
                                                    <td style={{ fontSize: "10px", textAlign: "left" }}>{item.descripcion}</td>
                                                    <td style={{ fontSize: "10px", textAlign: "right" }}>{item.monto == null ? "0,00" : formatMoneda(item.monto.toString().replace('.', ','), ',', '.', txtBolivares.current?.checked ? 2 : 4)}</td>
                                                </tr>

                                            ))
                                        }
                                    </tbody>

                                </TblContainer>
                                <div className="col-md-12 border-table mx-auto row px-0" style={{ borderTop: 'none' }} >
                                        <div className='col-md-8 row mx-auto'>
                                            <div className="row col-md-8 mx-auto my-auto">

                                                <div className="col">
                                                    <label htmlFor="inputRitm" style={{ fontSize: "16px", fontWeight: "bold" }}>Crédito a Favor: </label>
                                                </div>
                                                <div className="col">
                                                    <label htmlFor="inputRitm" style={{ fontSize: "16px", textAlign: "right", fontWeight: "bold" }}>{props.comercio ? props.comercio.credito !== null && props.comercio.credito > 0 ? props.comercio.credito : '0,00' : '0,00'}</label>
                                                </div>

                                            </div>
                                        </div>
                                        <div className='col-md-4 row'>

                                            <div class="input-group input-group-sm mb-0 col-md-12">
                                                <span class="input-group-text bg-transparent border-0" id="inputGroup-sizing-sm">Deuda:</span>
                                                <input type="text" value={deuda} class="form-control text-right bg-transparent border-0" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                                            </div>

                                            <div class="input-group input-group-sm mb-0 col-md-12">
                                                <span class="input-group-text bg-transparent border-0" id="inputGroup-sizing-sm">Intereses de Mora:</span>
                                                <input type="text" value={interes} class="form-control text-right bg-transparent border-0" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                                            </div>

                                            <div class="input-group input-group-sm mb-0 col-md-12">
                                                <span class="input-group-text bg-transparent border-0" id="inputGroup-sizing-sm">Recargo por Mora:</span>
                                                <input type="text" value={recargo} class="form-control text-right bg-transparent border-0" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                                            </div>

                                           

                                            <div class="input-group input-group-sm mb-0 col-md-12">
                                                <span class="input-group-text bg-transparent border-0" id="inputGroup-sizing-sm">Total de la Deuda:</span>
                                                <input type="text" value={totDeuda} class="form-control text-right bg-transparent border-0" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                                            </div>

                                        </div>
                                    </div>
                            </div>

                           {/*  <div className="row col-md-3 container" style={{ margin: 0, padding: 0 }}>
                           

                                <div className='row col-md-12 justify-content-center mx-auto' style={{visibility: visibleF }}>

                                    <div className="form-check form-check-inline col-md-12" style={{ ritght: 0 }}>

                                        <label className="form-check-label" htmlFor="inlineRadio2">Deuda en:</label>
                                    </div>

                                    <div className="form-check  col-md-6">
                                        <input className="form-check-input my-auto" ref={txtBolivares} type="radio" defaultChecked name="checkVAlor" value='1' id="checkVAlor"  onClick={calculo} />
                                        <label className="form-check-label" htmlFor="inlineRadio2">Bolivares</label>
                                    </div>

                                    <div className="form-check  col-md-6" >
                                        <input className="form-check-input my-auto" ref={txtPetro} type="radio" name="checkVAlor" value='2' id="checkVAlor" onClick={calculo} />
                                        <label className="form-check-label" htmlFor="inlineRadio2">Petro</label>
                                    </div>
                                </div>

                              

                                <div className="col-md-12 container-fluid">
                                    <div className="row justify-content-between">
                                        <div className="col-md-8">
                                            <label htmlFor="inputRitm">Deuda: </label>
                                        </div>
                                        <div className="col-md-4" style={{ textAlign: "right" }}>
                                            <label htmlFor="inputRitm">{deuda}</label>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-8">
                                            <label htmlFor="inputRitm">Intereses de Mora: </label>
                                        </div>
                                        <div className="col-md-4" style={{ textAlign: "right" }}>
                                            <label htmlFor="inputRitm">0.00</label>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-8">
                                            <label htmlFor="inputRitm">Recargo por Mora: </label>
                                        </div>
                                        <div className="col-md-4" style={{ textAlign: "right" }}>
                                            <label htmlFor="inputRitm">0.00</label>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-8">
                                            <label htmlFor="inputRitm">Total de la Deuda: </label>
                                        </div>
                                        <div className="col-md-4" style={{ textAlign: "right" }}>
                                            <label htmlFor="inputRitm" style={{ textAlign: "right" }}>{totDeuda}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-12" style={{ textAlign: "center"}}>
                                <div className="col-md-12">
                                    <label htmlFor="inputRitm" style={{ fontSize: "16px" }}> &nbsp; </label>
                                </div>
                                <div className="row">
                                    <div className="col-md-4">
                                        <label htmlFor="inputRitm" style={{ fontSize: "16px" }}> &nbsp; </label>
                                    </div>
                                    <div className="col-md-4">
                                        <label htmlFor="inputRitm" style={{ left: 0, fontSize: "16px", fontWeight: "bold" }}>Crédito a Favor:  {} </label>
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="inputRitm" style={{ fontSize: "16px" }}> &nbsp; </label>
                                    </div>
                                </div>

                            </div> */}


                        </div>
                    </div>
                </div>
            </div>
        </div>

    );

}

export default TablaDeudaLicores;
